<div class="page">
  <header class="page-header">
    <div>
      <h1>Partner invoicing</h1>
      <p class="lede">
        Generate monthly invoices for all partners, or inspect invoices for an
        individual partner.
      </p>
    </div>
  </header>

  <div *ngIf="partnersLoading" class="banner banner-info" role="status">
    Loading partner list…
  </div>
  <div *ngIf="!partnersLoading && partnersError" class="banner banner-warn" role="note">
    {{ partnersError }}
  </div>

  <ng-container *appHasPermission="P.PARTNER_MANAGE">
    <app-partner-monthly-invoice-generate />
  </ng-container>

  <!-- View: explicit ViewInvoices, or Manage (typically includes operational verification) -->
  <ng-container *appHasPermission="[P.PARTNER_VIEW_INVOICES, P.PARTNER_MANAGE]">
    <app-partner-invoices-grid [partners]="partners" />
  </ng-container>
</div>
